(() => {
  const forms = document.querySelectorAll('[data-strict-product-search]');
  if (!forms.length) return;

  const originalQuery = new URLSearchParams(window.location.search).get('thw_q');

  const quoteSearchValue = (value) => {
    const escaped = String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return `"${escaped}"`;
  };

  const tokenize = (value) => {
    const matches = String(value).match(/"([^"]+)"|\S+/g) || [];
    return matches
      .map((token) => token.replace(/^"|"$/g, '').trim())
      .filter(Boolean);
  };

  const buildStrictQuery = (value) => tokenize(value)
    .map((token) => {
      const quoted = quoteSearchValue(token);
      return `(title:${quoted} OR product_type:${quoted} OR variants.sku:${quoted})`;
    })
    .join(' AND ');

  forms.forEach((form) => {
    const input = form.querySelector('[data-strict-product-search-input]');
    if (!input) return;

    if (originalQuery) input.value = originalQuery;

    form.addEventListener('submit', (event) => {
      const humanQuery = input.value.trim();
      const strictQuery = buildStrictQuery(humanQuery);

      if (!strictQuery) {
        event.preventDefault();
        input.focus();
        return;
      }

      let originalInput = form.querySelector('[data-original-search-query]');
      if (!originalInput) {
        originalInput = document.createElement('input');
        originalInput.type = 'hidden';
        originalInput.name = 'thw_q';
        originalInput.dataset.originalSearchQuery = '';
        form.appendChild(originalInput);
      }

      originalInput.value = humanQuery;
      input.value = strictQuery;
    });
  });

  if (originalQuery) {
    document.querySelectorAll('[data-search-display-terms]').forEach((element) => {
      element.textContent = originalQuery;
    });

    document.querySelectorAll('[data-preserve-original-query]').forEach((input) => {
      input.value = originalQuery;
    });

    document.querySelectorAll('[data-preserve-original-query-link]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('thw_q', originalQuery);
        link.href = url.href;
      } catch (error) {
        // Leave an invalid or unavailable link unchanged.
      }
    });
  }

  // Keep the exact request first. If the search page reports zero exact
  // results, retry once with Shopify's normal search using the original words.
  const fallbackTrigger = document.querySelector('[data-search-fallback-trigger]');
  if (fallbackTrigger && originalQuery) {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('thw_fallback') !== '1') {
      const fallbackUrl = new URL(currentUrl.href);
      fallbackUrl.searchParams.set('q', originalQuery);
      fallbackUrl.searchParams.set('type', 'product');
      fallbackUrl.searchParams.set('thw_q', originalQuery);
      fallbackUrl.searchParams.set('thw_fallback', '1');
      fallbackUrl.searchParams.delete('page');
      window.location.replace(fallbackUrl.href);
    }
  }

  document.querySelectorAll('[data-clear-search-filters]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const currentUrl = new URL(window.location.href);
      const clearUrl = new URL(link.href, window.location.origin);

      // Use the current URL as the source of truth and remove every Shopify
      // facet/sort/pagination parameter, leaving the search query intact.
      [...clearUrl.searchParams.keys()].forEach((key) => {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
          clearUrl.searchParams.delete(key);
        }
      });
      if (currentUrl.searchParams.has('q')) {
        clearUrl.searchParams.set('q', currentUrl.searchParams.get('q'));
      }
      if (currentUrl.searchParams.has('thw_q')) {
        clearUrl.searchParams.set('thw_q', currentUrl.searchParams.get('thw_q'));
      }
      window.location.assign(clearUrl.href);
    });
  });
})();
